import {
    graphql
} from 'react-relay'


const query = graphql`
    query getAllBillingAddressQuery ($pagination: PaginationInput, $sorts: [OrderInput!], $where: JSON) {
        getAllBillingAddress (pagination: $pagination, sorts: $sorts, where: $where) {
            count,
            items {
                id
                customerId
                address
                isDefault
                countryId
                governorateId
                cityId
                country{id, name}
                governorate{id, name}
                city{id, name}
                createdAt
                updatedAt
            }
      }
    }
  `

  export default query;